import { useEffect } from 'react';
import { useInterval } from 'usehooks-ts';
import { useShallow } from 'zustand/react/shallow';
import { trimMessages, useMessageStore } from '@/stores/message';
import { usePeriodicMessageStore } from '@/stores/periodic-message';
import { isBurned } from '@/utils/check-messages-status';

export default function usePeriodicMessages() {
  const burnableMessages = usePeriodicMessageStore(useShallow((s) => s.burnableMessages));

  useInterval(
    () => {
      for (const sessionKey in burnableMessages) {
        const messages = burnableMessages[sessionKey];
        for (const messageId in messages) {
          const message = messages[messageId];
          if (!message) continue;

          if (isBurned(message)) {
            useMessageStore.getState().delete(message, 'GroupID' in message ? 'group' : 'session');
            usePeriodicMessageStore.getState().removeBurnableMessageId(sessionKey, message.ID);
          }
        }
      }
    },
    Object.keys(burnableMessages).length > 0 ? 250 : null,
  );

  useEffect(() => {
    trimMessages().catch(console.warn);
  }, []);
}
